import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, HeartSolid, LocationMarkerSolid, rem, Text, UserGroupSolid } from '@bonusly/design-system';
import { User } from '@bonusly/who-am-i';

interface UserPopoverCustomPropertiesProps {
	location?: string;
	department?: string;
	lastRecognition?: {
		receivers: Array<User>;
	};
}
export const UserPopoverCustomProperties: FC<UserPopoverCustomPropertiesProps> = ({ location, department, lastRecognition }) => {
	const { t } = useTranslation('components');

	if (!location && !lastRecognition) {
		return null;
	}
	return (
		<Grid gap={3} templateColumns={`${rem(21.6)} 1fr`} alignItems="center">
			{location ? (
				<>
					<LocationMarkerSolid size="sm" />
					<Text fontSize="sm" textTransform="capitalize">
						{location}
					</Text>
				</>
			) : null}
			{department ? (
				<>
					<UserGroupSolid size="sm" />
					<Text fontSize="sm" textTransform="capitalize">
						{department}
					</Text>
				</>
			) : null}
			{lastRecognition ? (
				<>
					<HeartSolid size="sm" />
					<Text fontSize="sm">
						{t('user_popover.recently_recognized', {
							name: lastRecognition.receivers[0].display_name,
							count: lastRecognition.receivers.length,
						})}
					</Text>
				</>
			) : null}
		</Grid>
	);
};
